export default __webpack_public_path__ + "static/media/footer_img.d97e545d.png";